import type { EntityAdapter, EntityState } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type { DevCourierOutput } from 'core/http/dev';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as CouriersActions from './couriers.actions';

export interface DevCouriersState extends EntityState<DevCourierOutput> {
  isLoaded: boolean;
  loading: boolean;
  error: Error | null;
  integrationClasses: string[];
}

const adapter: EntityAdapter<DevCourierOutput> = createEntityAdapter();

export const initialDevCouriersState = adapter.getInitialState<DevCouriersState>({
  isLoaded: false,
  loading: false,
  error: null,
  integrationClasses: new Array<string>(),
});

const reducer = createReducer(
  initialDevCouriersState,
  on(CouriersActions.getDevCouriers, CouriersActions.getClasses, state => ({ ...state, loading: true, error: null })),
  on(CouriersActions.saveCouriers, (state, { couriers }) => adapter.setAll(couriers, state)),
  on(CouriersActions.saveClasses, (state, { integrationClasses }) => ({ ...state, integrationClasses })),
  on(CouriersActions.markCouriersLoaded, state => ({ ...state, isLoaded: true, loading: false, error: null })),
  on(CouriersActions.setError, (state, { value }) => ({ ...state, loading: false, error: value })),
  on(CouriersActions.addCourierInStore, (state, { courier }) => adapter.addOne(courier, state)),
  on(CouriersActions.updateCourierInStore, (state, { update }) => adapter.updateOne(update, state)),
);

export function devCouriersReducer(state: DevCouriersState | undefined, action: Action): DevCouriersState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
} = adapter.getSelectors();
